import React, { useEffect, useState } from 'react'
import { BUTTON, HEROIMG, TEXT } from '../../layout/style'
import HeroImage from '../../componentFunction/Motion/HeroImage'
import { Button, Flex, theme, Typography } from 'antd'
import Lottie from 'react-lottie';
import animationData from '../../assets/image/HeroImage.json'
import { Link } from 'react-router-dom';

const { Text, Title } = Typography;


export default function WelcomeScreen() {
    const [isVisible, setIsVisible] = useState(true);
      const { token: { colorBgContainer, colorPrimary, borderRadiusLG, colorTextDescription }, } = theme.useToken();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setIsVisible(prevIsVisible => !prevIsVisible);
        }, 500);

        return () => clearInterval(intervalId);
    }, []);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <>
            <div style={HEROIMG.WRAPPER}>
                {/* <Lottie
                    options={defaultOptions}
                    height={250}
                    width={250}
                /> */}
                <HeroImage />

            </div>
            <h1 style={TEXT.heading1}>
            Welcome to OCTOPLEX<span style={{ visibility: isVisible ? 'visible' : 'hidden', color: colorPrimary }}>.</span>
            </h1>
            <Text type='secondary'>
            Explore OCTOPLEX's features to see how it can transform your board meetings and streamline workflow management.
            </Text>
            <br />
            <Flex gap={20}>
            <Link to="/login" style={{ textDecoration: 'none' }}>
                <Button type="primary" style={BUTTON.primary}>Login</Button>
            </Link>

            <Link hidden to="/register" style={{ textDecoration: 'none' }}>
                <Button style={BUTTON.default}>Register</Button>
            </Link>

            </Flex>
        </>
    )
}
